import type { Template } from './types';

/**
 * Write the active template name to `<html data-template="...">`. CSS rules
 * scoped under `[data-template='modern']` (and friends) hinge on this
 * attribute being set before paint.
 */
export function applyTemplate(template: Template): void {
  document.documentElement.dataset.template = template;
}
